export function formatMoney(value) {
  if (value === null || value === undefined) return "-";

  return new Intl.NumberFormat("es-PE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatPenalidadTooltip(item = {}) {
  const motivo =
    item.motivoPenalidad ??
    item.penalidadMotivo ??
    item.motivo_penalidad;
  if (motivo) {
    return String(motivo).trim();
  }

  const penalidades = item.penalidades ?? item.motivosPenalidad;
  if (!Array.isArray(penalidades) || !penalidades.length) {
    return "";
  }

  return penalidades
    .map((entry) => {
      if (typeof entry === "string") return entry.trim();

      const descripcion = entry?.descripcion ?? entry?.motivo ?? "";
      const monto = Number(entry?.monto);
      if (descripcion && Number.isFinite(monto)) {
        return `${descripcion}: S/ ${monto.toFixed(2)}`;
      }

      return descripcion || String(entry ?? "").trim();
    })
    .filter(Boolean)
    .join("\n");
}

export function formatText(value) {
  if (value === null || value === undefined) return "";
  return String(value);
}
